import { useState, useEffect } from 'react';
import api from '../utils/api';

const PROGRAM_ID = {
  praktikum: 1,
  msib: 3,
  mandiri: 6,
  volunteer: 11,
  bumdes: 12,
};

/**
 * Setiap program (Praktikum/MSIB/Mandiri/Volunteer) punya penomoran md_batch
 * sendiri-sendiri, jadi tidak bisa dibandingkan pakai 1 batchId yang sama.
 * Hook ini menerima 1 "cohort" (md_batch_main, periode gabungan lintas program),
 * lalu resolve batchId masing-masing program dari cohort.batches dan fetch
 * data taktis untuk tiap program secara paralel dengan batchId-nya sendiri.
 */
export default function useCohortDashboard(cohort) {
  const [management, setManagement] = useState({});
  const [funnel, setFunnel] = useState({});
  const [availability, setAvailability] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!cohort) return;

    const fetchData = async () => {
      setLoading(true);
      const programKeys = Object.keys(PROGRAM_ID);
      const nextAvailability = {};
      programKeys.forEach((key) => {
        nextAvailability[key] = Boolean(cohort.batches?.[key]);
      });
      setAvailability(nextAvailability);

      const results = await Promise.all(
        programKeys.map(async (key) => {
          const batchId = cohort.batches?.[key];
          if (!batchId) {
            return { key, mgmt: null, funnel: null };
          }
          try {
            const [mgmtRes, funnelRes] = await Promise.all([
              api.analyticsDashboardManagement({ batchId, programId: PROGRAM_ID[key] }),
              api.analyticsProgramFunnel({ batchId, programId: PROGRAM_ID[key] }),
            ]);
            return { key, mgmt: mgmtRes?.[key], funnel: funnelRes?.[key] };
          } catch (err) {
            console.error(`useCohortDashboard error for ${key}:`, err);
            return { key, mgmt: null, funnel: null };
          }
        })
      );

      const nextManagement = {};
      const nextFunnel = {};
      results.forEach(({ key, mgmt, funnel: funnelData }) => {
        nextManagement[key] = mgmt;
        nextFunnel[key] = funnelData;
      });

      setManagement(nextManagement);
      setFunnel(nextFunnel);
      setLoading(false);
    };

    fetchData();
  }, [cohort]);

  return { management, funnel, availability, loading };
}
